/* eslint-disable no-nested-ternary */
import React, { useState } from "react";

import { useHistory } from "react-router-dom";

// import {
//   DeveloperCompanyModel,
//   DeveloperCompanyResponseModel,
// } from "../../../../../domain/models/developer-company.model";
import { FilterModel } from "../../../../../domain/models/enum";

import BackButtom from "../../../../components/backButton";
import DataGrid from "../../../../components/datagrid";
import FilterBar from "../../../../components/filter-bar";

import { ContainerButton, Wrapper, ConfirmDialogStyled } from "./styles";
import { ExportButtonComponentStyled } from "../../solicitation/list/styles";

import makeFields from "./fields-factory";
import toastUtils from "../../../../../utils/ToastUtils";
import {
  DeveloperProps,
  DeveloperResponseModel,
} from "../../../../../domain/models/developer.model";
import { makeRemoteDeveloper } from "../../../../../main/factories/usecases/developer/remote-developer-factory";

type PageProps = {
  list: DeveloperResponseModel | undefined;
  setParams: any;
  // params: any
  handleReload: () => void;
  loading?: boolean;
  exportList?: () => Promise<void>;
};

const CompanyListPage = ({
  list,
  setParams,
  loading,
  exportList,
  handleReload,
}: PageProps): JSX.Element => {
  const [remove, setRemove] = useState<DeveloperProps | undefined>();

  const [shouldForcePage, setShouldForcePage] = useState<boolean>(false);

  const history = useHistory();

  const fields = makeFields(handleReload, setRemove, history);

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));

    setShouldForcePage(false);
  };

  const handleSearch = (callback: any): void => {
    const val = callback();

    setParams((prev: any) => ({
      ...prev,
      page: 0,
      filters: { name: val.query },
    }));

    setShouldForcePage(true);
  };

  return (
    <Wrapper>
      <BackButtom text="Listagem de empresas" />
      <FilterBar searchLabel="Pesquisar empresa:" handleFilter={handleSearch}>
        <ContainerButton>
          <ExportButtonComponentStyled
            onClick={async () => {
              if (exportList) {
                await exportList();
              }
            }}
          >
            Exportar lista
          </ExportButtonComponentStyled>
        </ContainerButton>
      </FilterBar>
      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
        shouldForcePage={shouldForcePage}
      />
      <ConfirmDialogStyled
        visible={!!remove}
        onHide={() => setRemove(undefined)}
        message="Você confirma a exclusão desse usuário?"
        // header="Confirmation"
        className="confirm-custom-dialog"
        acceptLabel="Sim"
        rejectLabel="Não"
        accept={async () => {
          try {
            await makeRemoteDeveloper().delete(remove?.id);
            handleReload();
            toastUtils.showMessage({
              type: "success",
              message: "Excluído com Sucesso!",
            });
          } catch (error: any) {
            toastUtils.showMessage({
              type: "error",
              message: error?.userMessage || error?.detail,
            });
          }
        }}
        reject={() => setRemove(undefined)}
      />
    </Wrapper>
  );
};
export default CompanyListPage;
